export interface ProductTaxInfo {
    ecoTax: number;
    ecoTaxDesc: string;
    tax: number;
    taxDesc: string;
    neto: number;
}

export class ProductTaxInfoHelper {

    static create(): ProductTaxInfo {
        return {
            ecoTax: 0,
            ecoTaxDesc: '',
            tax: 0,
            taxDesc: '',
            neto: 0,
        };
    }


    static getTotal(info: ProductTaxInfo): number {
        return info.neto + info.ecoTax + info.tax;
    }

    static transformFromApi(rows: Object[], neto: number) {
        const obj = ProductTaxInfoHelper.create();
        obj.neto = neto;
        for (const row of rows) {
            if (row['ARTICULO'] === 'IMPUESTO') {
                obj.tax = row['PRECIO'];
                obj.taxDesc = row['DESCRIPCION'];
            }
            if (row['DESCRIPCION'].search(/NFU/g) >= 0) {
                obj.ecoTax = row['PRECIO'];
                obj.ecoTaxDesc = row['DESCRIPCION'];
            }
        }
        return obj;
    }
}
